import { createAsyncThunk } from "@reduxjs/toolkit";
import { clearDrugSearch } from "../recentSearchService/index.js";

// Create a thunk that will be called when the component mounts
export const clearRecentDrugSearchesThunk = createAsyncThunk(
  "enhancedSearch/clearRecentSearches",
  async () => {
    return clearDrugSearch();
  },
);
